

























import { Vue } from 'vue-property-decorator'
import ScreenTile from '../components/ScreenTile.vue'
import DefaultDashBoard from '../components/DefaultDashBoard.vue'
import '../styles/home.css'

export default Vue.extend({
  data: function () {
    return {
      loading: false,
    }
  },
  components: {
    ScreenTile,
    DefaultDashBoard,
  },
})
